export default class CancelReport {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.report.remove();
    this.context.gateways.report.cancel();

    if (this.context.stores.embeddedReport.isLoading()) {
      this.context.stores.embeddedReport.resetLoading();
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/reporting/cancel_report.js